import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import { _RawMaterialByProductionOrder } from '../../../../../../../core/services/dataBean/EntityCatalogVdos';
import useModal, { MODAL_md } from '../../../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../../../theme/Component/Modal';
import { BasicTable, MASK_MONEY, MASK_NUMBER } from '../../../../../../theme/Component/BasicTable';


interface Props {
    idSelector: number;
    onChange: any;
    idProductionOrder: number;
    productionOrderDate: number;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const SelectInputRawMaterialByProductionOrder = ({ idSelector, onChange, label, returnType = "ID", render, idProductionOrder, productionOrderDate }: Props) => {

    const { instance, lista, setLista } = useDataBean(_RawMaterialByProductionOrder)
    const [id, setID] = useState(null);

    const modal = useModal("Materia Prima", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDRawMaterial == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getRawMaterialCatalogByProductionOrder(idProductionOrder, productionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDRawMaterial', visible: true },
        { title: 'Nombre', property: 'ProductName', visible: true },
        { title: 'Código', property: 'ProductCode', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true, mask: MASK_NUMBER },
        { title: 'Cantidad a Producir', property: 'ProductionQuantity', visible: true, mask: MASK_NUMBER },
        { title: 'Costo de Produccion', property: 'ProductCost', visible: true, MASK: MASK_MONEY },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Recurso"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDRawMaterial); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}